import { render } from "./PhasesComponent.vue?vue&type=template&id=5118ca3a&scoped=true"
import script from "./PhasesComponent.vue?vue&type=script&lang=js"
export * from "./PhasesComponent.vue?vue&type=script&lang=js"

import "./PhasesComponent.vue?vue&type=style&index=0&id=5118ca3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5118ca3a"]])

export default __exports__